import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { createForecastTrackingMatrix } from "../../utils/forecast_tracking_matrix";

export const ForecastTrackingContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "forecast_tracking",
        transformId: "forecast_tracking",
        folder: "outputs",
        title: "Forecast Tracking",
        dateHierarchyColumnFilter: null,
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          forecast: "forecast",
          "realized forecast": "realized forecast",
          orders: "orders",
          remainder: "remainder",
          "pct ordered": "pct ordered",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createForecastTrackingMatrix,
        chunkedMatrixTransformId: "forecast_tracking_matrix",
        excludeDetailRows: true,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
